import { render, staticRenderFns } from "./PersonalDataRegister.vue?vue&type=template&id=12059bd4&scoped=true&"
import script from "./PersonalDataRegister.vue?vue&type=script&lang=js&"
export * from "./PersonalDataRegister.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDataRegister.vue?vue&type=style&index=0&id=12059bd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12059bd4",
  null
  
)

export default component.exports